// BudgetGuard — separate password gate for the Budget Sheet module.
// Password: SSOWNER@24 (per user spec, Feb-2026). Cached in sessionStorage
// so the user only enters it once per tab.

import React, { useEffect, useState } from "react";
import { Lock, Unlock } from "lucide-react";

const BUDGET_PASSWORD = "SSOWNER@24";
const SESSION_KEY = "cpms_budget_unlocked";

export default function BudgetGuard({ children }) {
  const [unlocked, setUnlocked] = useState(false);
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) === "1") setUnlocked(true);
  }, []);

  const submit = (e) => {
    e.preventDefault();
    if (pwd === BUDGET_PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, "1");
      setUnlocked(true);
      setError("");
    } else {
      setError("Incorrect password");
    }
  };

  if (unlocked) return children;

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-6">
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-6 max-w-md w-full">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-md bg-amber-100 text-amber-700 flex items-center justify-center"><Lock size={18} /></div>
          <div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Restricted Access</div>
            <div className="text-lg font-semibold text-slate-900">Budget Sheet</div>
          </div>
        </div>
        <p className="text-sm text-slate-600 mb-5">
          Only the owner / authorised finance user may allocate budgets. Enter the Budget Sheet
          access password to continue.
        </p>
        <form onSubmit={submit} className="space-y-3">
          <input
            type="password"
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            placeholder="Budget Sheet password"
            autoFocus
            data-testid="budget-guard-password-input"
            className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1D2951]/20 focus:border-[#1D2951]"
          />
          {error && <div className="text-xs text-rose-600" data-testid="budget-guard-error">{error}</div>}
          <button
            type="submit"
            data-testid="budget-guard-submit"
            className="w-full bg-[#1D2951] hover:bg-[#2B3A67] text-white text-sm font-semibold px-3 py-2 rounded-md inline-flex items-center justify-center gap-2"
          >
            <Unlock size={14} /> Unlock Budget Sheet
          </button>
        </form>
      </div>
    </div>
  );
}
